/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { analyticsService } from 'src/app/plain-javascript/services/analytics/AnalyticsService';
import { DynamicFlagTypes } from '@touchplan/feature-flags';
import { DefaultLoggerService } from '@touchplan/logging';

function camelToSpace(text: string) {
	const result = text.replace(/([A-Z])/g, ' $1');
	return result.toLowerCase();
}

const logger = new DefaultLoggerService();
logger.setContext('ANALYTICS');

export function genAnalyticsBoilerplate(funcArgs: string[] = []) {
	return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
		const origFunction = descriptor.value;
		descriptor.value = function (...args: any[]) {
			const baseValues = origFunction.apply(this, args) || {};

			if (analyticsService.featureFlagManager?.getFlag(DynamicFlagTypes.ANALYTICS_SEGMENT_EVENTS)) {
				const obj: any = {};
				funcArgs.forEach((key, idx) => {
					if (args[idx] !== undefined) {
						obj[key] = args[idx];
					}
				});
				Object.assign(baseValues, obj);

				const spaceyName = camelToSpace(propertyKey);

				analyticsService.track(spaceyName, baseValues);

				if (analyticsService.featureFlagManager.getFlag(DynamicFlagTypes.ANALYTICS_CONSOLE_LOGGING)) {
					logger.log(spaceyName, baseValues);
				}
			}
		};
	};
}
